import { useCallback, useEffect } from 'react';
import { isSeoCrawler } from 'src/utils/seo/isSeoCrawler';
import useFTUEStorage from './useFTUEStorage';
export default function useFTUE(key, events = {}, forcedValue) {
    const [state, setState] = useFTUEStorage(key);
    const markComplete = useCallback(() => {
        setState(false);
    }, []);
    useEffect(() => {
        if (state === true) {
            events.onFTUE && events.onFTUE(markComplete);
        }
    }, [state, markComplete]);
    return [isSeoCrawler ? false : forcedValue ?? state, { markComplete }];
}
